"use client";

import { PagePayoutSchema } from "@/sanity/pages/PagePayoutTemplate";
import CertificateSection from "@/components/pageComponents/global/sections/CertificateSection";

export default function IntroSection({ data }: { data: PagePayoutSchema }) {
  return (
    <CertificateSection
      data={{
        chip: data.introChip,
        title: data.introTitle,
        text: data.introText,
        highlightedText: data.introHighlightedText,
        images: data.introImages,
      }}
    />
  );
}
